import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React, { useRef, useEffect } from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import { TabContext } from '../TabContext.js';
import styles from './styles.css.js';

function TabPanel(props) {
  const context = React.useContext(TabContext);
  const {
    name,
    elementRef,
    activeClassName,
    retainMount = 'none',
    className,
    ...otherProps
  } = props;
  const isLoadedOnce = useRef(false);
  let isActive = false;

  if (context.useHash) {
    isActive = context.hash === name;
  } else {
    isActive = context.activeTab === name;
  }

  useEffect(() => {
    if (isActive) {
      isLoadedOnce.current = true;
    }
  }, [isActive, retainMount]);

  if (retainMount === 'none' && !isActive) {
    return null;
  }

  if (retainMount === 'lazy' && !isLoadedOnce.current && !isActive) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: _cs(styles.tabPanel, className, isActive && activeClassName, !isActive && styles.hide),
    role: "tabpanel",
    ref: elementRef
  }));
}

var index = genericMemo(TabPanel);

export { index as default };
//# sourceMappingURL=index.js.map
